import { Pipe, PipeTransform } from '@angular/core';
import { UserRoleService } from '../services';
import { UserRole } from '../enums/global.enum';

@Pipe({
  name: 'userRoleChecker'
})
export class UserRoleCheckerPipe implements PipeTransform {

  constructor(private userRoleService: UserRoleService) {}

  transform(checkingRoles: UserRole[]): boolean {
    return this.userRoleService.isUserHasRoles(checkingRoles);
  }

}
